import React from 'react';
import { CMSContentPage } from '../components/CMSContentPage';
import { cmsApi } from '../services/cmsApi';

export const TermsAndConditions: React.FC = () => {
  return <CMSContentPage fetchContent={cmsApi.getTermsAndConditions} />;
};